<template>
  <!-- eslint-disable tailwindcss/no-custom-classname -->
  <div class="flex flex-col gap-4 md:gap-8">
    <RevSkeleton v-if="pending" height="100px" shape="rectangle" width="100%" />

    <RevSkeleton
      v-if="pending && isAITagsExperimentEnabled"
      height="100px"
      shape="rectangle"
      width="100%"
    />

    <RevSkeleton
      v-if="pending"
      class="self-end md:hidden"
      height="24px"
      shape="rectangle"
      width="50%"
    />

    <template v-if="!pending">
      <AIText v-if="aiSummary?.summary?.text" :text="aiSummary.summary.text">
        <template #info>
          <AIInfo :ai-summary class="hidden md:block" />
        </template>
      </AIText>

      <AITags
        v-if="isAITagsExperimentEnabled && aiSummary?.tags"
        class="mt-16"
        :tags="aiSummary.tags"
      />

      <AIInfo :ai-summary class="md:hidden" />
    </template>
  </div>
</template>

<script lang="ts" setup>
import type { ReviewsAISummary } from '@backmarket/nuxt-layer-reviews/api/reviews/types'
import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { RevSkeleton } from '@ds/components/Skeleton'

import AIInfo from '../AIInfo/AIInfo.vue'
import AITags from '../AITags/AITags.vue'
import AIText from '../AIText/AIText.vue'

const experiments = useExperiments()

defineProps<{
  aiSummary: ReviewsAISummary | undefined | null
  pending: boolean
}>()

const isAITagsExperimentEnabled =
  experiments['experiment.reviewsAiTags'] === 'withAITags'
</script>
